import { Box, Paper } from "@mui/material"
import Base from "../../../Base/views/Base"
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab'
import { useState } from "react";
import AtsTargetAchievementReports from "./AtsTargetAchievementReports";
import DailyProductivityReport from "./DailyProductivityReport";
import QualityReport from "./QualityReport";
import { useLocation } from "react-router-dom";
import WorkloadReports from "./WorkloadReports";
import AtsCandidateVerifiedReports from "./AtsCandidateVerifiedReports";
import MandateReport from "./MandateReport";
import ProductivityNewReport from "./ProductivityNewReport";
import MonthlyClosuresNewReport from "./MonthlyClosuresNewReport";
import YTDClosuresNewReport from "./YTDClosuresNewReport";
import WorkloadReportNew from "./WorkloadReportNew";
import DayTrackerReportNew from "./DayTrackerReportNew";
import MandateReportNew from "./MandateReportNew";
import AnalyticsReportNew from "./AnalyticsReportNew";
import RecruiterAchievementReportNew from "./RecruiterAchievementReportNew";
import { getDomain } from "../../../Base/helper/baseFunctions";

const AtsReportLandingPage = () => {
    const location = useLocation();
    const defaultValue = location.state?.defaultValue || "";
    const [value, setValue] = useState(defaultValue ? defaultValue : 0);
    const domain = getDomain();
    const isAllowedDomain = (domain === "cvtmeepl" || domain === "xpohrmeepl" || domain === "adobemeepl");
    

    function TabPanel(props) {
        const { children, value, index, ...other } = props;

        return (
            <div
                role="tabpanel"
                hidden={value !== index}
                id={`simple-tabpanel-${index}`}
                aria-labelledby={`simple-tab-${index}`}
                {...other}
            >
                {value === index && (
                    <Paper sx={{ height: "calc(100vh - 130px)", overflowY: "auto" }}>
                        {children}
                    </Paper>
                )}
            </div>
        );
    }

    TabPanel.propTypes = {
        children: PropTypes.node,
        index: PropTypes.number.isRequired,
        value: PropTypes.number.isRequired,
    };

    function a11yProps(index) {
        return {
            id: `simple-tab-${index}`,
            'aria-controls': `simple-tabpanel-${index}`,
        };
    }

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <Base>
           <Box sx={{ maxHeight: "calc(100vh - 75px)" }}>
                <Tabs value={value} onChange={handleChange} aria-label="basic tabs example" 
                    sx={{
                        minHeight: "40px", mb: 1, ".MuiTab-root": { minHeight: "20px" },
                        '& .MuiTabs-indicator': {
                            width: '100%',
                            display: 'flex',
                            justifyContent: "center !important",
                        },
                    }}
                    variant="scrollable"
                            orientation="horizontal"
                            allowScrollButtonsMobile={true}
                            >
                    
                    <Tab label="Productivity" {...a11yProps(0)} />
                    {/* <Tab label="Monthly Productivity" {...a11yProps(1)} /> */}
                    <Tab label="Achievement" {...a11yProps(1)} />
                    <Tab label="Quality" {...a11yProps(2)} />
                    <Tab label="WorkLoad" {...a11yProps(3)} />
                    <Tab label="Candidates Verified" {...a11yProps(4)} />
                    <Tab label="Mandate Report" {...a11yProps(5)} />
                    {isAllowedDomain && <Tab label="MonthlyClosures Report New" {...a11yProps(6)} />}
                    {isAllowedDomain && <Tab label="YTD Closures Report New" {...a11yProps(7)} />}
                    {isAllowedDomain && <Tab label="Workload Report New" {...a11yProps(8)} />}
                    {isAllowedDomain && <Tab label="Day Tracker Report New" {...a11yProps(9)} />}
                    {isAllowedDomain && <Tab label="Mandate Report New" {...a11yProps(10)} />}
                    {isAllowedDomain && <Tab label="Analytics Report New" {...a11yProps(11)} />}
                    {isAllowedDomain && <Tab label="Recruiter Achievement Report New" {...a11yProps(12)} />}
                </Tabs>
               
                <TabPanel value={value} index={0}>
                    <ProductivityNewReport />
                    {/* <DailyProductivityReport/> : this component need to be delete once all new reports are ready */}
                </TabPanel>
                {/* <TabPanel value={value} index={1}>
                     <MonthlyReport />
                </TabPanel> */}
                <TabPanel value={value} index={1}>
                    <AtsTargetAchievementReports />
                </TabPanel>
                <TabPanel value={value} index={2}>
                    <QualityReport />
                </TabPanel>
                <TabPanel value={value} index={3}>
                    <WorkloadReports />
                </TabPanel>
                <TabPanel value={value} index={4}>
                    <AtsCandidateVerifiedReports />
                </TabPanel>
                <TabPanel value={value} index={5}>
                    <MandateReport />
                </TabPanel>
                <TabPanel value={value} index={6}>
                    <MonthlyClosuresNewReport />
                </TabPanel>
                <TabPanel value={value} index={7}>
                    <YTDClosuresNewReport />
                </TabPanel>
                <TabPanel value={value} index={8}>
                    <WorkloadReportNew />
                </TabPanel>
                <TabPanel value={value} index={9}>
                    <DayTrackerReportNew />
                </TabPanel>
                <TabPanel value={value} index={10}>
                    <MandateReportNew />
                </TabPanel>
                <TabPanel value={value} index={11}>
                    <AnalyticsReportNew />
                </TabPanel>
                <TabPanel value={value} index={12}>
                    <RecruiterAchievementReportNew />
                </TabPanel>
            </Box>
        </Base>
    )
}

export default AtsReportLandingPage;